export const enum Vertical {
  Movies = "Movies",
  Series = "Television",
  Games = "Gaming",
  Franchises = "Franchises",
  Books = "Book",
  Talent = "Talent",
  Collections = "Collections",
  Anime = "Anime",
  Manga = "Manga",
};

export const prefixMap = {
  "film": Vertical.Movies,
  "series": Vertical.Series,
  "game": Vertical.Games,
  "franchise": Vertical.Franchises,
  "book": Vertical.Books,
  "nm": Vertical.Talent,
  "collection": Vertical.Collections,
  "anime": Vertical.Anime,
  "manga": Vertical.Manga,
};

export const Verticals = [Vertical.Movies, Vertical.Series, Vertical.Games];

export type VerticalOption = {
  label: string;
  value: Vertical | "all";
};

export const verticalOptions: VerticalOption[] = [
  { label: "Movies", value: Vertical.Movies },
  { label: "Series", value: Vertical.Series },
  { label: "Games", value: Vertical.Games },
];

export const verticalOptionsWithAll: VerticalOption[] = [
  { label: "All categories", value: "all" },
  { label: "Movies", value: Vertical.Movies },
  { label: "Series", value: Vertical.Series },
  { label: "Games", value: Vertical.Games },
];

export const verticalOptionsWithFranchiseAndAll: VerticalOption[] = [
  { label: "All categories", value: "all" },
  { label: "Movies", value: Vertical.Movies },
  { label: "Series", value: Vertical.Series },
  { label: "Games", value: Vertical.Games },
  { label: "Franchises", value: Vertical.Franchises },
];

export const getVerticalFromIpId = (ipId: string) => {
  if (!ipId) return null;
  const key = Object.keys(prefixMap).find((prefix) => ipId.startsWith(prefix));
  return key ? prefixMap[key] : null;
};

